import { SetupPermission } from 'src/app/core';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

export const BrandSettings: SetupPermission = PermissionsC.setupPages({
  pageLabels: ['general', 'notifications'],
  productLineLabel: 'brand-settings',
});
